import { contactLink } from "../lib/api";
import React, { useRef } from "react";
import Hero from "../components/Hero";
import Products from "../components/Products";
import WhyBuy from "../components/WhyBuy";
import HowToOrder from "../components/HowToOrder";
import FAQ from "../components/FAQ";
import Reviews from "../components/Reviews";
import { useReveal } from "../hooks/useReveal";
import { Send } from "lucide-react";
import { siteConfig as fallback } from "../mock";
import { useSite } from "../context/SiteContext";
import WaveDivider from "../components/WaveDivider";

const Home = () => {
  useReveal([]);
  const { settings } = useSite();
  const siteConfig = settings || fallback;

  const scrollToProducts = () =>
    document.getElementById("products")?.scrollIntoView({ behavior: "smooth" });

  return (
    <div>
      <Hero onShop={scrollToProducts} />
      <Products />
      <WaveDivider />
      <WhyBuy />
      <HowToOrder />
      <FAQ />
      <Reviews />

      {/* CTA */}
      <section className="bg-navy-800 py-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="reveal relative overflow-hidden rounded-3xl glass-gold-card liquid-bg p-10 md:p-16 text-center">
            <div className="absolute inset-0 opacity-[0.05]"
              style={{ backgroundImage: "radial-gradient(#d4af37 1px, transparent 1px)", backgroundSize: "24px 24px" }} />
            <div className="relative">
              <h2 className="text-3xl md:text-4xl font-bold text-white">
                Ready to Level Up Your <span className="gold-gradient-text">Next Shoot?</span>
              </h2>
              <p className="mt-4 text-slate-300 max-w-xl mx-auto">
                Join creators nationwide who trust {siteConfig.brandName} for
                premium, camera-ready prop bills.
              </p>
              <div className="mt-8 flex flex-wrap justify-center gap-4">
                <button
                  onClick={scrollToProducts}
                  data-testid="cta-shop-btn"
                  className="btn-liquid text-navy font-bold px-8 py-3.5 rounded-xl"
                >
                  <span className="relative z-10">Shop the Collection</span>
                </button>
                <a
                  {...contactLink(siteConfig.contact?.telegramLink)}
                  className="inline-flex items-center gap-2 text-white border border-gold/30 hover:border-gold px-8 py-3.5 rounded-xl transition-colors duration-200"
                >
                  <Send size={17} /> Message Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
